// asset-class-indices-collapsable-table.component.ts
// Vendor libraries
import { ChangeDetectorRef } from '@angular/core';
// Services
import { IndicesService } from 'IndicesApp/ts/shared/services/indices.service';
import * as i0 from "@angular/core";
import * as i1 from "IndicesApp/ts/shared/services/indices.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = () => [];
function AssetClassIndicesCollapsableTableComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "ycn-loading-symbol", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", "Loading Indices...");
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_ng_container_5_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31)(1, "div", 32)(2, "a", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r1 = i0.ɵɵnextContext().index;
    const subTableParent_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", subTableParent_r2.indices[i_r1].url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(subTableParent_r2.indices[i_r1].name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_ng_container_5_td_1_Template, 4, 2, "td", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r1 = ctx.index;
    const subTableParent_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const default_r3 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subTableParent_r2.indices && subTableParent_r2.indices[i_r1])("ngIfElse", default_r3);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 27)(1, "tr", 28)(2, "td", 29)(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_ng_container_5_Template, 2, 2, "ng-container", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subTableParent_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("id", subTableParent_r2.display_name + "Tab");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(subTableParent_r2.display_name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(3, _c0).constructor(3));
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_ng_container_5_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31)(1, "div", 32)(2, "a", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext().index;
    const subTableParent_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", subTableParent_r2.indices[i_r6].url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(subTableParent_r2.indices[i_r6].name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_ng_container_5_td_1_Template, 4, 2, "td", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r6 = ctx.index;
    const subTableParent_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const default_r3 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subTableParent_r2.indices && subTableParent_r2.indices[i_r6])("ngIfElse", default_r3);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody", 34);
    i0.ɵɵlistener("click", function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_Template_tbody_click_0_listener() { i0.ɵɵrestoreView(_r4); const subTableParent_r2 = i0.ɵɵnextContext().$implicit; const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.dropdownHandler(subTableParent_r2.display_name)); });
    i0.ɵɵelementStart(1, "tr", 28)(2, "td", 29)(3, "div", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_ng_container_5_Template, 2, 2, "ng-container", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subTableParent_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("id", subTableParent_r2.display_name + "Tab");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(subTableParent_r2.display_name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(3, _c0).constructor(3));
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 29)(1, "div", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(subItem_r7.display_name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 29)(1, "div", 38)(2, "div", 38);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(subItem_r7.display_name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 29)(1, "div", 38)(2, "div", 38)(3, "div", 38);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(subItem_r7.display_name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 29)(1, "div", 38)(2, "div", 38)(3, "div", 38)(4, "div", 38);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(subItem_r7.display_name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 29)(1, "div", 38)(2, "div", 38)(3, "div", 38)(4, "div", 38)(5, "div", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(subItem_r7.display_name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_ng_container_6_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31)(1, "div", 32)(2, "a", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r8 = i0.ɵɵnextContext().index;
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", subItem_r7.indices[i_r8].url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(subItem_r7.indices[i_r8].name);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_ng_container_6_td_1_Template, 4, 2, "td", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r8 = ctx.index;
    const subItem_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(4);
    const default_r3 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subItem_r7.indices && subItem_r7.indices[i_r8])("ngIfElse", default_r3);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 36);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_1_Template, 3, 1, "td", 37)(2, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_2_Template, 4, 1, "td", 37)(3, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_3_Template, 5, 1, "td", 37)(4, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_4_Template, 6, 1, "td", 37)(5, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_td_5_Template, 7, 1, "td", 37)(6, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_ng_container_6_Template, 2, 2, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r7 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", subItem_r7.indent_level);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", 2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", 3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", 4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", 5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(7, _c0).constructor(3));
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_1_Template, 6, 4, "tbody", 23)(2, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tbody_2_Template, 6, 4, "tbody", 24);
    i0.ɵɵelementStart(3, "tbody", 25);
    i0.ɵɵtemplate(4, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_tr_4_Template, 7, 8, "tr", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subTableParent_r2 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r4.subTableDict[subTableParent_r2.display_name] == null ? null : ctx_r4.subTableDict[subTableParent_r2.display_name].length) === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r4.subTableDict[subTableParent_r2.display_name] == null ? null : ctx_r4.subTableDict[subTableParent_r2.display_name].length) != 0);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", subTableParent_r2.display_name + "Dropdown");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.subTableDict[subTableParent_r2.display_name]);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_ng_container_1_Template, 5, 4, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.subTableParents);
} }
function AssetClassIndicesCollapsableTableComponent_table_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 18)(1, "thead")(2, "tr");
    i0.ɵɵelement(3, "td", 19);
    i0.ɵɵelementStart(4, "td", 20);
    i0.ɵɵtext(5, "Index 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 20);
    i0.ɵɵtext(7, "Index 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td", 20);
    i0.ɵɵtext(9, "Index 3");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, AssetClassIndicesCollapsableTableComponent_table_15_ng_container_10_Template, 2, 1, "ng-container", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const noDataTemplate_r9 = i0.ɵɵreference(21);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", !ctx_r4.noData)("ngIfElse", noDataTemplate_r9);
} }
function AssetClassIndicesCollapsableTableComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31)(1, "div", 32);
    i0.ɵɵtext(2, " -- ");
    i0.ɵɵelementEnd()();
} }
function AssetClassIndicesCollapsableTableComponent_ng_template_20_tr_3_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 31)(1, "div", 32);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd()();
} }
function AssetClassIndicesCollapsableTableComponent_ng_template_20_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 28);
    i0.ɵɵelement(1, "td", 29);
    i0.ɵɵtemplate(2, AssetClassIndicesCollapsableTableComponent_ng_template_20_tr_3_td_2_Template, 3, 0, "td", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(3));
} }
function AssetClassIndicesCollapsableTableComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1, "No Data Available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "tbody");
    i0.ɵɵtemplate(3, AssetClassIndicesCollapsableTableComponent_ng_template_20_tr_3_Template, 3, 2, "tr", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c0).constructor(10));
} }
export class AssetClassIndicesCollapsableTableComponent {
    constructor(changeDetector, indicesService) {
        this.changeDetector = changeDetector;
        this.indicesService = indicesService;
        this.loading = true;
        this.noData = false;
        this.indexTableData = [];
        this.subTableDict = {};
        this.subTableParents = [];
    }
    ngOnInit() {
        this.getTableData();
    }
    getSubtables() {
        let curr_parent_internal = '';
        this.indexTableData.forEach((asset) => {
            if (asset.indent_level === 0) {
                this.subTableParents.push(asset);
                curr_parent_internal = asset.display_name;
                this.subTableDict[curr_parent_internal] = [];
            }
            else {
                this.subTableDict[curr_parent_internal].push(asset);
            }
        });
    }
    getTableData() {
        this.loading = true;
        this.indicesService.getAllAssetClassIndices(this.parentAssetClass).subscribe({
            next: (response) => {
                this.indexTableData = response.asset_classes;
                this.noData = this.indexTableData.length === 0;
                this.loading = false;
                this.getSubtables();
                // open the first subtable
                if (!this.noData) {
                    this.changeDetector.detectChanges();
                    this.dropdownHandler(this.subTableParents[0].display_name);
                }
            },
            error: () => {
                this.noData = true;
                this.loading = false;
            },
        });
    }
    dropdownHandler(id) {
        const subTable = document.getElementById(`${id}Dropdown`);
        const parentTab = document.getElementById(`${id}Tab`);
        if (parentTab && subTable) {
            subTable.classList.toggle('show');
            parentTab.classList.toggle('show');
            parentTab.classList.toggle('active');
        }
    }
}
AssetClassIndicesCollapsableTableComponent.ɵfac = function AssetClassIndicesCollapsableTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AssetClassIndicesCollapsableTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.IndicesService)); };
AssetClassIndicesCollapsableTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AssetClassIndicesCollapsableTableComponent, selectors: [["ycn-asset-class-indices-collapsable-table"]], inputs: { parentAssetClass: "parentAssetClass", parentAssetClassDisplay: "parentAssetClassDisplay" }, standalone: false, decls: 22, vars: 4, consts: [["default", ""], ["noDataTemplate", ""], [1, "container"], ["id", "pageTabs", 1, "page-tabs", "tab-content"], [1, "tab-pane", "active"], [1, "page-header", "row"], [1, "page-title", "col-auto"], [1, "page-name", "mr-1"], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], ["ng-controller", "overflowShadow", 1, "ng-scope"], [1, "overflow-shadow-x"], [1, "panel-content", "overflow-shadow-inner"], ["class", "panel-content d-flex justify-content-center align-items-center", 4, "ngIf"], ["class", "table", 4, "ngIf"], [1, "panel-content", "d-flex", "justify-content-center", "align-items-center"], [3, "loaderMessage"], [1, "table"], [1, "colTxtXLong"], [1, "text-thin"], [4, "ngIf", "ngIfElse"], [4, "ngFor", "ngForOf"], [3, "id", 4, "ngIf"], ["class", "subtable-toggle", "data-toggle", "collapse", 3, "id", "click", 4, "ngIf"], [1, "subtable", "table-striped", 3, "id"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "id"], [1, "tr-overlined"], [1, "text-left"], ["class", "td-index", 4, "ngIf", "ngIfElse"], [1, "td-index"], [1, "td-ellipsis"], [1, "td-ellipsis-content", "width-240", 3, "href"], ["data-toggle", "collapse", 1, "subtable-toggle", 3, "click", "id"], [1, "dropdown-toggle"], [3, "ngSwitch"], ["class", "text-left", 4, "ngSwitchCase"], [1, "ml-20"], [1, "panel-data-empty-message"], ["class", "tr-overlined", 4, "ngFor", "ngForOf"], ["class", "td-index", 4, "ngFor", "ngForOf"]], template: function AssetClassIndicesCollapsableTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "div", 7);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "div", 8)(8, "div", 9)(9, "h3", 10);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 11)(12, "div", 12)(13, "div", 13);
        i0.ɵɵtemplate(14, AssetClassIndicesCollapsableTableComponent_div_14_Template, 2, 1, "div", 14)(15, AssetClassIndicesCollapsableTableComponent_table_15_Template, 11, 2, "table", 15);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(16, "p");
        i0.ɵɵtext(17, "The indices shown above are chosen by YCharts as an index that fits within the given asset class and are in no way promoted by or affiliated with YCharts.");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(18, AssetClassIndicesCollapsableTableComponent_ng_template_18_Template, 3, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(20, AssetClassIndicesCollapsableTableComponent_ng_template_20_Template, 4, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1("", ctx.parentAssetClassDisplay, " Indices");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", ctx.parentAssetClassDisplay, " Indices");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i3.LoadingSymbolComponent], encapsulation: 2 });
